(function () {
  'use strict';
  var root = document.querySelector('[data-sr-ride-finder-page]');
  if (!root || root.dataset.finderInitialized) return;
  root.dataset.finderInitialized = 'true';
  var questions = Array.from(root.querySelectorAll('.sr-ride-finder-page__question'));
  var selected = Object.create(null), step = 0, started = false, completed = false, generation = 0;
  var catalog = null, catalogPromise = null, matches = [], completionPublished = false;
  var query = function (selector) { return root.querySelector(selector); };
  var productsPanel = query('[data-sr-ride-products]');
  var resultPanel = query('[data-sr-ride-result-panel]');
  var productsList = query('[data-sr-ride-products-list]');
  var next = query('[data-sr-next]'), prev = query('[data-sr-prev]');
  var status = query('[data-sr-status]'), retry = query('[data-sr-retry]');
  var summary = query('[data-sr-summary]');
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function publish(event, properties) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: event, finder_version: 'ride-finder-v2' }, properties || {}));
  }
  function announce(message) { if (status) status.textContent = message; }
  function focusPanel(panel) {
    if (!panel) return;
    var heading = panel.querySelector('h2') || panel;
    heading.setAttribute('tabindex', '-1');
    heading.focus({ preventScroll: true });
    panel.scrollIntoView({ block: 'start', behavior: reduced ? 'auto' : 'smooth' });
  }
  function displayQuestion(index, focus) {
    generation += 1;
    completed = false;
    query('.sr-ride-finder-page__quiz').hidden = false;
    var copyStatus = query('[data-sr-copy-status]'); if (copyStatus) copyStatus.textContent = '';
    if (summary) summary.hidden = true;
    var summaryLabel = query('[data-sr-summary-label]'); if (summaryLabel) summaryLabel.hidden = true;
    step = Math.max(0, Math.min(index, questions.length - 1));
    questions.forEach(function (question, i) { question.hidden = i !== step; });
    productsPanel.hidden = true;
    resultPanel.hidden = true;
    var navigation = query('[data-sr-navigation]');
    if (navigation) navigation.hidden = false;
    prev.hidden = step === 0;
    next.hidden = false;
    next.disabled = false;
    next.textContent = step === questions.length - 1 ? 'See my options' : 'Continue';
    query('[data-sr-ride-progress]').textContent = 'Question ' + (step + 1) + ' of ' + questions.length;
    query('.sr-ride-finder-page__progress').style.setProperty('--sr-progress', ((step + 1) / questions.length * 100) + '%');
    if (retry) retry.hidden = true;
    announce('');
    if (focus) focusPanel(questions[step]);
  }
  function sameOriginUrl(value) {
    var url = new URL(value, window.location.origin);
    if (url.origin !== window.location.origin || !/^https?:$/.test(url.protocol)) throw new Error('Invalid catalogue URL');
    return url;
  }
  async function fetchCatalog() {
    if (catalog) return catalog;
    if (catalogPromise) return catalogPromise;
    catalogPromise = (async function () {
      if (!root.dataset.catalogUrl) throw new Error('Missing catalogue URL');
      var url = sameOriginUrl(root.dataset.catalogUrl), visited = new Set(), all = [], expectedPage = 1, pageCount = null;
      while (url) {
        if (visited.has(url.href) || visited.size >= 200) throw new Error('Invalid catalogue pagination');
        visited.add(url.href);
        var controller = new AbortController();
        var timeout = window.setTimeout(function () { controller.abort(); }, 20000);
        var response;
        try { response = await fetch(url.href, { credentials: 'same-origin', signal: controller.signal }); }
        finally { window.clearTimeout(timeout); }
        if (!response.ok) throw new Error('Catalogue unavailable');
        var documentPage = new DOMParser().parseFromString(await response.text(), 'text/html');
        var script = documentPage.querySelector('script[data-sr-finder-catalog]');
        if (!script) throw new Error('Missing catalogue data');
        var data = JSON.parse(script.textContent);
        if (!Array.isArray(data.products) || Number(data.page) !== expectedPage || !Number.isInteger(Number(data.pages)) || Number(data.pages) < 1) throw new Error('Incomplete catalogue data');
        if (pageCount !== null && pageCount !== Number(data.pages)) throw new Error('Catalogue changed during loading');
        pageCount = Number(data.pages);
        all = all.concat(data.products);
        if (expectedPage < pageCount && !data.nextPageUrl) throw new Error('Missing catalogue page');
        if (expectedPage === pageCount && data.nextPageUrl) throw new Error('Unexpected catalogue page');
        url = data.nextPageUrl ? sameOriginUrl(data.nextPageUrl) : null;
        if (url) url.searchParams.set('section_id', 'sr-ride-finder-catalog');
        expectedPage += 1;
      }
      catalog = all;
      return all;
    }());
    try { return await catalogPromise; }
    finally { catalogPromise = null; }
  }
  function options() {
    var preferences = [], categoryScores = {};
    Object.keys(selected).forEach(function (key) {
      var button = selected[key];
      (button.dataset.preferences || '').split(',').filter(Boolean).forEach(function (value) { if (preferences.indexOf(value) === -1) preferences.push(value); });
      (button.dataset.score || '').split(',').forEach(function (pair) {
        var parts = pair.split(':');
        if (parts.length === 2) categoryScores[parts[0]] = (categoryScores[parts[0]] || 0) + (Number(parts[1]) || 0);
      });
    });
    var typeTokens = selected['2'] ? (selected['2'].dataset.preferences || '').split(',') : [];
    var vehicleType = typeTokens.find(function (token) { return ['ebike', 'scooter', 'seated-scooter', 'board', 'moped', 'trike', 'cargo', 'mobility'].indexOf(token) !== -1; }) || null;
    var result = { preferences: preferences, vehicleType: vehicleType, categoryScores: categoryScores, limit: 4 };
    if (typeTokens.indexOf('offroad') !== -1) result.allowedVehicleTypes = ['dirt', 'atv', 'go-kart', 'snow', 'utility', 'kids'];
    return result;
  }
  function element(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  }
  function productUrl(match) {
    var url = sameOriginUrl(match.product.url || '/products/' + encodeURIComponent(match.product.handle));
    url.searchParams.set('variant', String(match.variant.id));
    return url.href;
  }
  function price(match) {
    return new Intl.NumberFormat('en-CA', { style: 'currency', currency: 'CAD' }).format(match.priceCents / 100) + ' CAD';
  }
  function renderProduct(match, rank) {
    var row = element('li', 'sr-ride-finder-page__product is-visible');
    row.setAttribute('data-sr-ride-product', '');
    row.dataset.handle = match.product.handle;
    row.dataset.resultRank = String(rank);
    var imageUrl = match.product.image || match.product.imageUrl;
    if (imageUrl) {
      var parsedImage = new URL(imageUrl, window.location.origin);
      if (/^https?:$/.test(parsedImage.protocol)) {
        var image = element('img');
        image.src = parsedImage.href; image.alt = match.product.title; image.loading = 'lazy'; image.width = 120; image.height = 120;
        var media = element('a', 'sr-ride-finder-page__product-image');
        media.href = productUrl(match); media.tabIndex = -1; media.setAttribute('aria-hidden', 'true'); media.appendChild(image); row.appendChild(media);
      }
    }
    var details = element('div');
    var link = element('a', '', match.product.title);
    link.href = productUrl(match); details.appendChild(link);
    if (match.variant.title && match.variant.title !== 'Default Title') details.appendChild(element('span', '', match.variant.title));
    details.appendChild(element('p', 'sr-ride-finder-page__fit-reason', (match.reasons || []).join(' · ')));
    if (match.checks && match.checks.length) {
      var checks = element('details', 'sr-ride-finder-page__fit-checks');
      checks.appendChild(element('summary', '', 'Fit details to confirm'));
      checks.appendChild(element('p', '', match.checks.join('; ') + '.'));
      details.appendChild(checks);
    }
    row.appendChild(details);
    var cost = element('div');
    cost.appendChild(element('strong', '', price(match)));
    cost.appendChild(element('small', '', 'Before tax and shipping'));
    row.appendChild(cost);
    return row;
  }
  function summaryText() {
    var lines = ['My Street Rides fit-check answers:'];
    questions.forEach(function (question, index) {
      var button = question.querySelector('[data-sr-ride-answer]');
      var answer = button && selected[button.dataset.question];
      if (answer) lines.push((index + 1) + '. ' + question.querySelector('h2').textContent.trim() + ' — ' + answer.textContent.trim());
    });
    lines.push('', 'Options to compare:');
    if (!matches.length) lines.push('No in-stock option could be confirmed for these selections.');
    matches.forEach(function (match, index) { lines.push((index + 1) + '. ' + match.product.title + ' — ' + price(match) + ' before tax and shipping', productUrl(match)); });
    lines.push('', 'Please help confirm rider fit, route range, carrying capacity and local-use suitability.');
    return lines.join('\n');
  }
  async function complete() {
    var token = ++generation;
    next.disabled = true;
    if (retry) retry.hidden = true;
    announce('Checking the complete in-stock catalogue…');
    try {
      var all = await fetchCatalog();
      if (token !== generation) return;
      if (!window.StreetRidesFinderEngine) throw new Error('Finder unavailable');
      var result = window.StreetRidesFinderEngine.recommend(all, options());
      matches = result.matches;
      var cards = matches.map(function (match, index) { return renderProduct(match, index + 1); });
      productsList.replaceChildren.apply(productsList, cards);
      query('[data-sr-ride-products-title]').textContent = matches.length ? 'Your in-stock shortlist' : 'No confirmed option for these selections';
      query('[data-sr-ride-products-note]').textContent = matches.length
        ? 'These options meet your budget and any confirmed folding or frame needs. Check range, rider fit, terrain, and local rules before choosing.'
        : 'We checked the complete catalogue. An in-stock option within your budget and confirmed must-haves was not found. Edit your answers or send the summary below for help.';
      questions.forEach(function (question) { question.hidden = true; });
      query('.sr-ride-finder-page__quiz').hidden = true;
      var navigation = query('[data-sr-navigation]'); if (navigation) navigation.hidden = true;
      prev.hidden = true; next.hidden = true;
      productsPanel.hidden = false; resultPanel.hidden = false;
      query('[data-sr-ride-progress]').textContent = questions.length + ' of ' + questions.length + ' answered';
      if (query('[data-sr-ride-result-title]')) query('[data-sr-ride-result-title]').textContent = 'Save your answers or ask us to check';
      if (query('[data-sr-ride-result-body]')) query('[data-sr-ride-result-body]').textContent = 'Your summary includes your answers and the exact options shown above.';
      if (summary) summary.value = summaryText();
      var whatsapp = query('[data-sr-whatsapp-fit-check]');
      if (whatsapp) { var whatsappUrl = new URL(whatsapp.href); whatsappUrl.searchParams.set('text', summaryText()); whatsapp.href = whatsappUrl.href; }
      var reset = query('[data-sr-ride-reset]'); if (reset) reset.hidden = false;
      completed = true; announce(''); focusPanel(productsPanel);
      if (!completionPublished) { publish('sr_ride_finder_completed', { answered_questions: questions.length, result_count: matches.length }); completionPublished = true; }
      publish('sr_ride_finder_result', { result_count: matches.length, eligible_count: result.total, catalog_count: all.length, recommended_handles: matches.map(function (match) { return match.product.handle; }).join('|') });
    } catch (error) {
      if (token !== generation) return;
      productsPanel.hidden = true; resultPanel.hidden = true;
      announce('We could not load the complete catalogue. Your answers are still here. Please retry to see your options.');
      if (retry) retry.hidden = false;
      publish('sr_ride_finder_catalog_error');
    } finally { if (token === generation) next.disabled = false; }
  }
  root.addEventListener('click', function (event) {
    var button = event.target.closest('[data-sr-ride-answer]');
    if (button) {
      if (!started) { started = true; publish('sr_ride_finder_start'); fetchCatalog().catch(function () {}); }
      if (selected[button.dataset.question] !== button) completionPublished = false;
      selected[button.dataset.question] = button;
      button.closest('.sr-ride-finder-page__question').querySelectorAll('[data-sr-ride-answer]').forEach(function (other) { other.classList.toggle('is-selected', other === button); other.setAttribute('aria-pressed', String(other === button)); });
      announce('');
      publish('sr_ride_finder_answer', { question: button.dataset.question, answer: button.dataset.preferences || '' });
      return;
    }
    if (event.target.closest('[data-sr-next]')) {
      var first = questions[step].querySelector('[data-sr-ride-answer]');
      if (!selected[first.dataset.question]) { announce('Choose an answer before continuing.'); first.focus(); return; }
      if (step === questions.length - 1) complete(); else displayQuestion(step + 1, true);
    }
    if (event.target.closest('[data-sr-prev]')) displayQuestion(step - 1, true);
    if (event.target.closest('[data-sr-edit]')) displayQuestion(0, true);
    if (event.target.closest('[data-sr-retry]')) complete();
    if (event.target.closest('[data-sr-ride-reset]')) {
      selected = Object.create(null); matches = []; started = false; completionPublished = false;
      root.querySelectorAll('[data-sr-ride-answer]').forEach(function (answer) { answer.classList.remove('is-selected'); answer.setAttribute('aria-pressed', 'false'); });
      if (summary) summary.value = '';
      displayQuestion(0, true); publish('sr_ride_finder_reset');
    }
    if (event.target.closest('[data-sr-copy-answers]') && completed) {
      var copyStatus = query('[data-sr-copy-status]');
      var text = summaryText(); if (summary) { summary.value = text; summary.hidden = false; }
      var summaryLabel = query('[data-sr-summary-label]'); if (summaryLabel) summaryLabel.hidden = false;
      var copy = navigator.clipboard && navigator.clipboard.writeText ? navigator.clipboard.writeText(text) : Promise.reject(new Error('Clipboard unavailable'));
      copy.then(function () { if (copyStatus) copyStatus.textContent = 'Copied. Paste this into your message or email.'; publish('sr_ride_finder_answers_copied'); }).catch(function () {
        if (summary) { summary.focus(); summary.select(); }
        if (copyStatus) copyStatus.textContent = 'Select and copy the summary below, then paste it into your message or email.';
      });
    }
    var productLink = event.target.closest('[data-sr-ride-product] a[href]');
    if (productLink) { var row = productLink.closest('[data-sr-ride-product]'); publish('sr_ride_finder_product_click', { product_handle: row.dataset.handle, result_rank: Number(row.dataset.resultRank) }); }
    if (event.target.closest('[data-sr-whatsapp-fit-check]')) publish('sr_ride_finder_whatsapp_click', { result_count: matches.length });
  });
  root.querySelectorAll('[data-sr-ride-answer]').forEach(function (answer) { answer.setAttribute('aria-pressed', 'false'); });
  displayQuestion(0, false);
  publish('sr_ride_finder_view');
}());
